import React from "react";
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {CyClass} from "../../../../../../../common/cy-classes";
import {SwedenGamingLimitsButtonBox} from "./boxes/sweden.gaming-limits-button.box";
import {CHANNEL_ELEMENTS} from "../../../../../../../common/const/casinofied-analytics-consts";
import {AreaType, ControlCenterOpenSource} from "@sparkware/uc-sdk-core";
import {SwedenResponsibleGamingButtonSBGIconClassName} from "../boxes/sweden.responsible-gaming-button-base.box";

interface SwedenGamingLimitsButtonComponentProps {
    useIconsOnly: boolean;
    isShownInHeader: boolean;
}

export const SwedenGamingLimitsButtonComponent = observer(
    class SwedenGamingLimitsButtonComponent extends OrbitComponent<SwedenGamingLimitsButtonComponentProps> {
        private _onClickHandler = async () => {
            this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", 'Icon_deposit_limits_click');

            await this.services.externalLinks.openGameLimits({
                channelArea:AreaType.button,
                channelElement:CHANNEL_ELEMENTS.gamesLimitsGameButton,
                source: ControlCenterOpenSource.RgPolicy
        });
        }

        render() {
                const GamingLimitIcon = this.services.theme.currentTheme.icons.gamingLimitRegulationIcon;
                const GamingLimitSymbolIcon = this.services.theme.currentTheme.icons.gamingLimitRegulationSymbolIcon;

                return (
                    <SwedenGamingLimitsButtonBox className={CyClass('cy-sweden-game-limit-button')} useIconsOnly={this.props.useIconsOnly} isShownInHeader={this.props.isShownInHeader} onClick={this._onClickHandler}>
                        {this.props.useIconsOnly ?  <GamingLimitSymbolIcon size={2.5} className={CyClass('cy-sweden-game-limit-icon')}/>
                            : <GamingLimitIcon className={CyClass('cy-sweden-game-limit-icon') + " " + SwedenResponsibleGamingButtonSBGIconClassName} />}
                    </SwedenGamingLimitsButtonBox>)

        }
    }
);